"use strict";
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.19.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IpsApiException = exports.Software = exports.SequencingStats = exports.RunPagedItems = exports.Run = exports.InstrumentWashUnpagedItems = exports.InstrumentWash = exports.InstrumentUtilizationUnpagedItems = exports.InstrumentUtilizationBin = exports.InstrumentUtilization = exports.InstrumentUnpagedItems = exports.InstrumentTimeSeriesMetricName = exports.InstrumentTimeSeriesChartItemUnpagedItems = exports.InstrumentTimeSeriesChartItem = exports.InstrumentPlatform = exports.Instrument = exports.GetUserRunRequestIncludeFields = exports.ErrorResponse = exports.EnvironmentUnpagedItems = exports.Environment = exports.DateFilterFields = exports.CreateInstrumentPlatformCatalog = exports.Consumables = exports.CatalogUnpagedItems = exports.Catalog = exports.BinBy = exports.InstrumentClient = exports.ipsApiUrl = void 0;
/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
const operators_1 = require("rxjs/operators");
const rxjs_1 = require("rxjs");
const core_1 = require("@angular/core");
const http_1 = require("@angular/common/http");
exports.ipsApiUrl = new core_1.InjectionToken('ipsApiUrl');
let InstrumentClient = class InstrumentClient {
    constructor(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:5000";
    }
    /**
     * Create catalog number for instrument platform
     * @param body (optional)
     * @return The catalog number is created successfully.
     */
    postInstrumentPlatformCatalog(body) {
        let url_ = this.baseUrl + "/v1/performance/admin/catalogs";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(operators_1.mergeMap((response_) => {
            return this.processPostInstrumentPlatformCatalog(response_);
        })).pipe(operators_1.catchError((response_) => {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return this.processPostInstrumentPlatformCatalog(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    }
    processPostInstrumentPlatformCatalog(response) {
        const status = response.status;
        const responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 201) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(_responseText => {
                let result201 = null;
                let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = Catalog.fromJS(resultData201);
                return rxjs_1.of(result201);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(_responseText => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ErrorResponse.fromJS(resultData400);
                return throwException("An invalid or missing input parameter will result in a bad request.", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 401) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(_responseText => {
                let result401 = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = ErrorResponse.fromJS(resultData401);
                return throwException("The acting identity cannot be authenticated and authorized.", status, _responseText, _headers, result401);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    }
    /**
     * Get a list of registered environments
     * @return The request succeeded.
     */
    getEnvironments() {
        let url_ = this.baseUrl + "/v1/performance/environments";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(operators_1.mergeMap((response_) => {
            return this.processGetEnvironments(response_);
        })).pipe(operators_1.catchError((response_) => {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return this.processGetEnvironments(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    }
    processGetEnvironments(response) {
        const status = response.status;
        const responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(_responseText => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = EnvironmentUnpagedItems.fromJS(resultData200);
                return rxjs_1.of(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(_responseText => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ErrorResponse.fromJS(resultData400);
                return throwException("An invalid or missing input parameter will result in a bad request.", status, _responseText, _headers, result400);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    }
    /**
     * Get run utilization from a list of instruments within a date range
     * @param serialNumbers Comma separated list of instrument serial numbers
     * @param fromDate Beginning of range
     * @param timeZone The user timezone
     * @param toDate (optional) End of range
     * @param binBy (optional) Period for dividing results into "bins"
     * @param includeEmptyBins (optional) Flag that indicates whether to list bins with zero instrument utilization (no runs)
     * @return The instrument utilization info is returned successfully.
     */
    getInstrumentUtilization(serialNumbers, fromDate, timeZone, toDate, binBy, includeEmptyBins) {
        let url_ = this.baseUrl + "/v1/performance/instruments/utilization?";
        if (serialNumbers === undefined || serialNumbers === null)
            throw new Error("The parameter 'serialNumbers' must be defined and cannot be null.");
        else
            serialNumbers && serialNumbers.forEach(item => { url_ += "SerialNumbers=" + encodeURIComponent("" + item) + "&"; });
        if (fromDate === undefined || fromDate === null)
            throw new Error("The parameter 'fromDate' must be defined and cannot be null.");
        else
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (timeZone === undefined || timeZone === null)
            throw new Error("The parameter 'timeZone' must be defined and cannot be null.");
        else
            url_ += "TimeZone=" + encodeURIComponent("" + timeZone) + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (binBy !== undefined && binBy !== null)
            url_ += "BinBy=" + encodeURIComponent("" + binBy) + "&";
        if (includeEmptyBins !== undefined && includeEmptyBins !== null)
            url_ += "IncludeEmptyBins=" + encodeURIComponent("" + includeEmptyBins) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(operators_1.mergeMap((response_) => {
            return this.processGetInstrumentUtilization(response_);
        })).pipe(operators_1.catchError((response_) => {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return this.processGetInstrumentUtilization(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    }
    processGetInstrumentUtilization(response) {
        const status = response.status;
        const responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(_responseText => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = InstrumentUtilizationUnpagedItems.fromJS(resultData200);
                return rxjs_1.of(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(_responseText => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ErrorResponse.fromJS(resultData400);
                return throwException("An invalid or missing input parameter will result in a bad request.", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 401) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(_responseText => {
                let result401 = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = ErrorResponse.fromJS(resultData401);
                return throwException("The acting identity cannot be authenticated and authorized.", status, _responseText, _headers, result401);
            }));
        }
        else if (status === 403) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(_responseText => {
                let result403 = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ErrorResponse.fromJS(resultData403);
                return throwException("The acting identity cannot be authenticated and authorized.", status, _responseText, _headers, result403);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    }
    /**
     * Get instrument info for the provided list of serial numbers
     * @param serialNumbers Comma separated list of instrument serial numbers
     * @param includeActiveRuns (optional) Set this flag to true to see active runs in the response
     * @return The instrument info are returned successfully.
     */
    getInstruments(serialNumbers, includeActiveRuns) {
        let url_ = this.baseUrl + "/v1/performance/instruments?";
        if (serialNumbers === undefined || serialNumbers === null)
            throw new Error("The parameter 'serialNumbers' must be defined and cannot be null.");
        else
            serialNumbers && serialNumbers.forEach(item => { url_ += "SerialNumbers=" + encodeURIComponent("" + item) + "&"; });
        if (includeActiveRuns !== undefined && includeActiveRuns !== null)
            url_ += "IncludeActiveRuns=" + encodeURIComponent("" + includeActiveRuns) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(operators_1.mergeMap((response_) => {
            return this.processGetInstruments(response_);
        })).pipe(operators_1.catchError((response_) => {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return this.processGetInstruments(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    }
    processGetInstruments(response) {
        const status = response.status;
        const responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(_responseText => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = InstrumentUnpagedItems.fromJS(resultData200);
                return rxjs_1.of(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(_responseText => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ErrorResponse.fromJS(resultData400);
                return throwException("An invalid or missing input parameter will result in a bad request.", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 401) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(_responseText => {
                let result401 = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = ErrorResponse.fromJS(resultData401);
                return throwException("The acting identity cannot be authenticated and authorized.", status, _responseText, _headers, result401);
            }));
        }
        else if (status === 403) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(_responseText => {
                let result403 = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ErrorResponse.fromJS(resultData403);
                return throwException("The acting identity cannot be authenticated and authorized.", status, _responseText, _headers, result403);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    }
    /**
     * Get timeseries chart data for instrument runs
     * @param metricName The name of the metric to return
     * @param serialNumbers Comma separated list of serial numbers
     * @param fromDate Date to filter runs that started on or after this date
     * @param catalogNumbers (optional) Comma separated list of catalog numbers
     * @param toDate (optional) Date to filter runs that started before this date
     * @return The request succeeded.
     */
    getInstrumentTimeSeriesChartData(metricName, serialNumbers, fromDate, catalogNumbers, toDate) {
        let url_ = this.baseUrl + "/v1/performance/instruments/charts/timeseries?";
        if (metricName === undefined || metricName === null)
            throw new Error("The parameter 'metricName' must be defined and cannot be null.");
        else
            url_ += "MetricName=" + encodeURIComponent("" + metricName) + "&";
        if (serialNumbers === undefined || serialNumbers === null)
            throw new Error("The parameter 'serialNumbers' must be defined and cannot be null.");
        else
            serialNumbers && serialNumbers.forEach(item => { url_ += "SerialNumbers=" + encodeURIComponent("" + item) + "&"; });
        if (fromDate === undefined || fromDate === null)
            throw new Error("The parameter 'fromDate' must be defined and cannot be null.");
        else
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (catalogNumbers !== undefined && catalogNumbers !== null)
            catalogNumbers && catalogNumbers.forEach(item => { url_ += "CatalogNumbers=" + encodeURIComponent("" + item) + "&"; });
        if (toDate !== undefined && toDate !== null)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(operators_1.mergeMap((response_) => {
            return this.processGetInstrumentTimeSeriesChartData(response_);
        })).pipe(operators_1.catchError((response_) => {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return this.processGetInstrumentTimeSeriesChartData(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    }
    processGetInstrumentTimeSeriesChartData(response) {
        const status = response.status;
        const responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(_responseText => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = InstrumentTimeSeriesChartItemUnpagedItems.fromJS(resultData200);
                return rxjs_1.of(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(_responseText => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ErrorResponse.fromJS(resultData400);
                return throwException("An invalid or missing input parameter will result in a bad request.", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 401) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(_responseText => {
                let result401 = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = ErrorResponse.fromJS(resultData401);
                return throwException("The acting identity cannot be authenticated and authorized.", status, _responseText, _headers, result401);
            }));
        }
        else if (status === 403) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(_responseText => {
                let result403 = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ErrorResponse.fromJS(resultData403);
                return throwException("The acting identity cannot be authenticated and authorized.", status, _responseText, _headers, result403);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    }
    /**
     * Get instrument wash events for the provided list of serial numbers
     * @param fromDate Date to filter runs that started on or after this date
     * @param toDate (optional) Date to filter runs that started before this date
     * @return The instrument wash events are returned successfully.
     */
    getInstrumentWashes(serialNumbers, fromDate, toDate) {
        let url_ = this.baseUrl + "/v1/performance/instruments/washes?";
        if (serialNumbers === undefined || serialNumbers === null)
            throw new Error("The parameter 'serialNumbers' must be defined and cannot be null.");
        else
            serialNumbers && serialNumbers.forEach(item => { url_ += "SerialNumbers=" + encodeURIComponent("" + item) + "&"; });
        if (fromDate === undefined || fromDate === null)
            throw new Error("The parameter 'fromDate' must be defined and cannot be null.");
        else
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(operators_1.mergeMap((response_) => {
            return this.processGetInstrumentWashes(response_);
        })).pipe(operators_1.catchError((response_) => {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return this.processGetInstrumentWashes(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    }
    processGetInstrumentWashes(response) {
        const status = response.status;
        const responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(_responseText => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = InstrumentWashUnpagedItems.fromJS(resultData200);
                return rxjs_1.of(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(_responseText => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ErrorResponse.fromJS(resultData400);
                return throwException("An invalid or missing input parameter will result in a bad request.", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 401) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(_responseText => {
                let result401 = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = ErrorResponse.fromJS(resultData401);
                return throwException("The acting identity cannot be authenticated and authorized.", status, _responseText, _headers, result401);
            }));
        }
        else if (status === 403) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(_responseText => {
                let result403 = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ErrorResponse.fromJS(resultData403);
                return throwException("The acting identity cannot be authenticated and authorized.", status, _responseText, _headers, result403);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    }
    /**
     * Get a list of catalogs available for given instrument platforms.
     * @param instrumentPlatforms Comma separated list of instrument platforms
     * @return The request succeeded.
     */
    getCatalogsForInstrumentPlatforms(instrumentPlatforms) {
        let url_ = this.baseUrl + "/v1/performance/instrumentplatforms/catalogs?";
        if (instrumentPlatforms === undefined || instrumentPlatforms === null)
            throw new Error("The parameter 'instrumentPlatforms' must be defined and cannot be null.");
        else
            instrumentPlatforms && instrumentPlatforms.forEach(item => { url_ += "InstrumentPlatforms=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(operators_1.mergeMap((response_) => {
            return this.processGetCatalogsForInstrumentPlatforms(response_);
        })).pipe(operators_1.catchError((response_) => {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return this.processGetCatalogsForInstrumentPlatforms(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    }
    processGetCatalogsForInstrumentPlatforms(response) {
        const status = response.status;
        const responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(_responseText => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CatalogUnpagedItems.fromJS(resultData200);
                return rxjs_1.of(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(_responseText => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ErrorResponse.fromJS(resultData400);
                return throwException("An invalid or missing input parameter will result in a bad request.", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 401) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(_responseText => {
                let result401 = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = ErrorResponse.fromJS(resultData401);
                return throwException("The acting identity cannot be authenticated and authorized.", status, _responseText, _headers, result401);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    }
    /**
     * Get a list of runs within a date range for the given instrument numbers
     * @param serialNumbers Comma separated list of serial numbers. Max of 100 serial numbers.
     * @param statuses (optional) Comma separated list of run states to filter on. Possible values: Failed or Stopped
     * @param fromDate (optional) Date to filter runs that started or completed (based on DateFilterField) after or on this date.
     * @param toDate (optional) Date to filter runs that started or completed (based on DateFilterField) before this date.
     * @param dateFilterField (optional) Either InstrumentStartedOn or InstrumentCompletedOn. Default is InstrumentStartedOn.
     * @param pageSize (optional)
     * @param pageToken (optional)
     * @param sort (optional)
     * @return The run list info is returned successfully.
     */
    getRunsForInstruments(serialNumbers, statuses, fromDate, toDate, dateFilterField, pageSize, pageToken, sort) {
        let url_ = this.baseUrl + "/v1/performance/instruments/runs?";
        if (serialNumbers === undefined || serialNumbers === null)
            throw new Error("The parameter 'serialNumbers' must be defined and cannot be null.");
        else
            serialNumbers && serialNumbers.forEach(item => { url_ += "SerialNumbers=" + encodeURIComponent("" + item) + "&"; });
        if (statuses !== undefined && statuses !== null)
            statuses && statuses.forEach(item => { url_ += "Statuses=" + encodeURIComponent("" + item) + "&"; });
        if (fromDate !== undefined && fromDate !== null)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (dateFilterField !== undefined && dateFilterField !== null)
            url_ += "DateFilterField=" + encodeURIComponent("" + dateFilterField) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageToken !== undefined && pageToken !== null)
            url_ += "pageToken=" + encodeURIComponent("" + pageToken) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(operators_1.mergeMap((response_) => {
            return this.processGetRunsForInstruments(response_);
        })).pipe(operators_1.catchError((response_) => {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return this.processGetRunsForInstruments(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    }
    processGetRunsForInstruments(response) {
        const status = response.status;
        const responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(_responseText => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = RunPagedItems.fromJS(resultData200);
                return rxjs_1.of(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(_responseText => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ErrorResponse.fromJS(resultData400);
                return throwException("An invalid or missing input parameter will result in a bad request.", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 401) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(_responseText => {
                let result401 = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = ErrorResponse.fromJS(resultData401);
                return throwException("The acting identity cannot be authenticated and authorized.", status, _responseText, _headers, result401);
            }));
        }
        else if (status === 403) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(_responseText => {
                let result403 = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ErrorResponse.fromJS(resultData403);
                return throwException("The acting identity cannot be authenticated and authorized.", status, _responseText, _headers, result403);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    }
    /**
     * Get info about a specific run
     * @return The run info is returned successfully.
     */
    getRun(id) {
        let url_ = this.baseUrl + "/v1/performance/instruments/runs/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(operators_1.mergeMap((response_) => {
            return this.processGetRun(response_);
        })).pipe(operators_1.catchError((response_) => {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return this.processGetRun(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    }
    processGetRun(response) {
        const status = response.status;
        const responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(_responseText => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Run.fromJS(resultData200);
                return rxjs_1.of(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(_responseText => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ErrorResponse.fromJS(resultData400);
                return throwException("An invalid or missing input parameter will result in a bad request.", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 401) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(_responseText => {
                let result401 = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = ErrorResponse.fromJS(resultData401);
                return throwException("The acting identity cannot be authenticated and authorized.", status, _responseText, _headers, result401);
            }));
        }
        else if (status === 403) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(_responseText => {
                let result403 = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ErrorResponse.fromJS(resultData403);
                return throwException("The acting identity cannot be authenticated and authorized.", status, _responseText, _headers, result403);
            }));
        }
        else if (status === 404) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(_responseText => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ErrorResponse.fromJS(resultData404);
                return throwException("Run not found", status, _responseText, _headers, result404);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    }
    /**
     * Get list of instruments accessible to the user
     * @param apiUrl The BSSH api url to get data from
     * @param fromDate (optional) Date to filter instruments that started on or after this date
     * @param toDate (optional) Date to filter instruments that started before this date
     * @return List of instruments accessible to the logged in user.
     */
    getUserInstruments(apiUrl, fromDate, toDate) {
        let url_ = this.baseUrl + "/v1/performance/user/instruments?";
        if (apiUrl === undefined || apiUrl === null)
            throw new Error("The parameter 'apiUrl' must be defined and cannot be null.");
        else
            url_ += "ApiUrl=" + encodeURIComponent("" + apiUrl) + "&";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(operators_1.mergeMap((response_) => {
            return this.processGetUserInstruments(response_);
        })).pipe(operators_1.catchError((response_) => {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return this.processGetUserInstruments(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    }
    processGetUserInstruments(response) {
        const status = response.status;
        const responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(_responseText => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = InstrumentUnpagedItems.fromJS(resultData200);
                return rxjs_1.of(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(_responseText => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ErrorResponse.fromJS(resultData400);
                return throwException("An invalid or missing input parameter will result in a bad request.", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 401) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(_responseText => {
                let result401 = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = ErrorResponse.fromJS(resultData401);
                return throwException("The acting identity cannot be authenticated and authorized.", status, _responseText, _headers, result401);
            }));
        }
        else if (status === 403) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(_responseText => {
                let result403 = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ErrorResponse.fromJS(resultData403);
                return throwException("The acting identity cannot be authenticated and authorized.", status, _responseText, _headers, result403);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    }
    /**
     * Get timeseries chart data for a user's instrument runs
     * @param apiUrl The BSSH api url to get data from
     * @param metricName The name of the metric to return
     * @param serialNumbers Comma separated list of serial numbers
     * @param fromDate Date to filter runs that started on or after this date
     * @param catalogNumbers (optional) Comma separated list of catalog numbers
     * @param toDate (optional) Date to filter runs that started before this date
     * @return The request succeeded.
     */
    getUserInstrumentTimeSeriesChartData(apiUrl, metricName, serialNumbers, fromDate, catalogNumbers, toDate) {
        let url_ = this.baseUrl + "/v1/performance/user/instruments/charts/timeseries?";
        if (apiUrl === undefined || apiUrl === null)
            throw new Error("The parameter 'apiUrl' must be defined and cannot be null.");
        else
            url_ += "ApiUrl=" + encodeURIComponent("" + apiUrl) + "&";
        if (metricName === undefined || metricName === null)
            throw new Error("The parameter 'metricName' must be defined and cannot be null.");
        else
            url_ += "MetricName=" + encodeURIComponent("" + metricName) + "&";
        if (serialNumbers === undefined || serialNumbers === null)
            throw new Error("The parameter 'serialNumbers' must be defined and cannot be null.");
        else
            serialNumbers && serialNumbers.forEach(item => { url_ += "SerialNumbers=" + encodeURIComponent("" + item) + "&"; });
        if (fromDate === undefined || fromDate === null)
            throw new Error("The parameter 'fromDate' must be defined and cannot be null.");
        else
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (catalogNumbers !== undefined && catalogNumbers !== null)
            catalogNumbers && catalogNumbers.forEach(item => { url_ += "CatalogNumbers=" + encodeURIComponent("" + item) + "&"; });
        if (toDate !== undefined && toDate !== null)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(operators_1.mergeMap((response_) => {
            return this.processGetUserInstrumentTimeSeriesChartData(response_);
        })).pipe(operators_1.catchError((response_) => {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return this.processGetUserInstrumentTimeSeriesChartData(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    }
    processGetUserInstrumentTimeSeriesChartData(response) {
        const status = response.status;
        const responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(_responseText => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = InstrumentTimeSeriesChartItemUnpagedItems.fromJS(resultData200);
                return rxjs_1.of(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(_responseText => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ErrorResponse.fromJS(resultData400);
                return throwException("An invalid or missing input parameter will result in a bad request.", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 401) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(_responseText => {
                let result401 = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = ErrorResponse.fromJS(resultData401);
                return throwException("The acting identity cannot be authenticated and authorized.", status, _responseText, _headers, result401);
            }));
        }
        else if (status === 403) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(_responseText => {
                let result403 = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ErrorResponse.fromJS(resultData403);
                return throwException("The user does not have access to one or more serial number(s) in the request", status, _responseText, _headers, result403);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    }
    /**
     * Export in csv format timeseries chart data for a user's instrument runs
     * @param serialNumbers Comma separated list of instrument serial numbers
     * @param fromDate Date to filter runs that started on or after this date
     * @param apiUrl The BSSH api url to get data from
     * @param catalogNumbers (optional) Comma separated list of catalog numbers
     * @param toDate (optional) Date to filter runs that started before this date
     * @return The request succeeded.
     */
    exportUserInstrumentTimeSeriesChartData(serialNumbers, fromDate, apiUrl, catalogNumbers, toDate) {
        let url_ = this.baseUrl + "/v1/performance/user/instruments/runs/export?";
        if (serialNumbers === undefined || serialNumbers === null)
            throw new Error("The parameter 'serialNumbers' must be defined and cannot be null.");
        else
            serialNumbers && serialNumbers.forEach(item => { url_ += "SerialNumbers=" + encodeURIComponent("" + item) + "&"; });
        if (fromDate === undefined || fromDate === null)
            throw new Error("The parameter 'fromDate' must be defined and cannot be null.");
        else
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (apiUrl === undefined || apiUrl === null)
            throw new Error("The parameter 'apiUrl' must be defined and cannot be null.");
        else
            url_ += "ApiUrl=" + encodeURIComponent("" + apiUrl) + "&";
        if (catalogNumbers !== undefined && catalogNumbers !== null)
            catalogNumbers && catalogNumbers.forEach(item => { url_ += "CatalogNumbers=" + encodeURIComponent("" + item) + "&"; });
        if (toDate !== undefined && toDate !== null)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Accept": "text/csv"
            })
        };
        return this.http.request("get", url_, options_).pipe(operators_1.mergeMap((response_) => {
            return this.processExportUserInstrumentTimeSeriesChartData(response_);
        })).pipe(operators_1.catchError((response_) => {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return this.processExportUserInstrumentTimeSeriesChartData(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    }
    processExportUserInstrumentTimeSeriesChartData(response) {
        const status = response.status;
        const responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return rxjs_1.of({ fileName: fileName, data: responseBlob, status: status, headers: _headers });
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(_responseText => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ErrorResponse.fromJS(resultData400);
                return throwException("An invalid or missing input parameter will result in a bad request.", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 401) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(_responseText => {
                let result401 = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = ErrorResponse.fromJS(resultData401);
                return throwException("The acting identity cannot be authenticated and authorized.", status, _responseText, _headers, result401);
            }));
        }
        else if (status === 403) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(_responseText => {
                let result403 = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ErrorResponse.fromJS(resultData403);
                return throwException("The user does not have access to one or more serial number(s) in the request", status, _responseText, _headers, result403);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    }
    /**
     * Get info about a specific run a user can access
     * @param apiUrl The BSSH api url to get data from
     * @param include (optional) Fields to include in the response
     * @return The run info is returned successfully.
     */
    getUserRun(id, apiUrl, include) {
        let url_ = this.baseUrl + "/v1/performance/user/instruments/runs/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (apiUrl === undefined || apiUrl === null)
            throw new Error("The parameter 'apiUrl' must be defined and cannot be null.");
        else
            url_ += "ApiUrl=" + encodeURIComponent("" + apiUrl) + "&";
        if (include !== undefined && include !== null)
            include && include.forEach(item => { url_ += "Include=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            observe: "response",
            responseType: "blob",
            headers: new http_1.HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(operators_1.mergeMap((response_) => {
            return this.processGetUserRun(response_);
        })).pipe(operators_1.catchError((response_) => {
            if (response_ instanceof http_1.HttpResponseBase) {
                try {
                    return this.processGetUserRun(response_);
                }
                catch (e) {
                    return rxjs_1.throwError(e);
                }
            }
            else
                return rxjs_1.throwError(response_);
        }));
    }
    processGetUserRun(response) {
        const status = response.status;
        const responseBlob = response instanceof http_1.HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(_responseText => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Run.fromJS(resultData200);
                return rxjs_1.of(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(_responseText => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ErrorResponse.fromJS(resultData400);
                return throwException("An invalid or missing input parameter will result in a bad request.", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 401) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(_responseText => {
                let result401 = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = ErrorResponse.fromJS(resultData401);
                return throwException("The acting identity cannot be authenticated and authorized.", status, _responseText, _headers, result401);
            }));
        }
        else if (status === 403) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(_responseText => {
                let result403 = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ErrorResponse.fromJS(resultData403);
                return throwException("The acting identity cannot be authenticated and authorized.", status, _responseText, _headers, result403);
            }));
        }
        else if (status === 404) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(_responseText => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ErrorResponse.fromJS(resultData404);
                return throwException("Run not found", status, _responseText, _headers, result404);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(operators_1.mergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return rxjs_1.of(null);
    }
};
InstrumentClient = __decorate([
    core_1.Injectable({
        providedIn: 'root'
    }),
    __param(0, core_1.Inject(http_1.HttpClient)), __param(1, core_1.Optional()), __param(1, core_1.Inject(exports.ipsApiUrl)),
    __metadata("design:paramtypes", [http_1.HttpClient, String])
], InstrumentClient);
exports.InstrumentClient = InstrumentClient;
var BinBy;
(function (BinBy) {
    BinBy["Unspecified"] = "Unspecified";
    BinBy["Week"] = "Week";
    BinBy["Month"] = "Month";
})(BinBy = exports.BinBy || (exports.BinBy = {}));
class Catalog {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.catalogNumber = _data["catalogNumber"];
            this.description = _data["description"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Catalog();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["catalogNumber"] = this.catalogNumber;
        data["description"] = this.description;
        return data;
    }
}
exports.Catalog = Catalog;
class CatalogUnpagedItems {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (let item of _data["items"])
                    this.items.push(Catalog.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CatalogUnpagedItems();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}
exports.CatalogUnpagedItems = CatalogUnpagedItems;
class Consumables {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.flowcellPart = _data["flowcellPart"];
            this.reagentPart = _data["reagentPart"];
            this.catalogNumber = _data["catalogNumber"];
            this.reagentBarcode = _data["reagentBarcode"];
            this.flowcellBarcode = _data["flowcellBarcode"];
            this.catalogDescription = _data["catalogDescription"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Consumables();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["flowcellPart"] = this.flowcellPart;
        data["reagentPart"] = this.reagentPart;
        data["catalogNumber"] = this.catalogNumber;
        data["reagentBarcode"] = this.reagentBarcode;
        data["flowcellBarcode"] = this.flowcellBarcode;
        data["catalogDescription"] = this.catalogDescription;
        return data;
    }
}
exports.Consumables = Consumables;
class CreateInstrumentPlatformCatalog {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.instrumentPlatform = _data["instrumentPlatform"];
            this.catalogNumber = _data["catalogNumber"];
            this.reagentPartNumber = _data["reagentPartNumber"];
            this.flowcellPartNumber = _data["flowcellPartNumber"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateInstrumentPlatformCatalog();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["instrumentPlatform"] = this.instrumentPlatform;
        data["catalogNumber"] = this.catalogNumber;
        data["reagentPartNumber"] = this.reagentPartNumber;
        data["flowcellPartNumber"] = this.flowcellPartNumber;
        return data;
    }
}
exports.CreateInstrumentPlatformCatalog = CreateInstrumentPlatformCatalog;
var DateFilterFields;
(function (DateFilterFields) {
    DateFilterFields["InstrumentStartedOn"] = "InstrumentStartedOn";
    DateFilterFields["InstrumentCompletedOn"] = "InstrumentCompletedOn";
})(DateFilterFields = exports.DateFilterFields || (exports.DateFilterFields = {}));
class Environment {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.apiUrl = _data["apiUrl"];
            this.webUrl = _data["webUrl"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Environment();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["apiUrl"] = this.apiUrl;
        data["webUrl"] = this.webUrl;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        return data;
    }
}
exports.Environment = Environment;
class EnvironmentUnpagedItems {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (let item of _data["items"])
                    this.items.push(Environment.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new EnvironmentUnpagedItems();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}
exports.EnvironmentUnpagedItems = EnvironmentUnpagedItems;
/** Details for an error which occurred */
class ErrorResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.code = _data["code"];
            this.message = _data["message"];
            if (Array.isArray(_data["details"])) {
                this.details = [];
                for (let item of _data["details"])
                    this.details.push(item);
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["message"] = this.message;
        if (Array.isArray(this.details)) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item);
        }
        return data;
    }
}
exports.ErrorResponse = ErrorResponse;
var GetUserRunRequestIncludeFields;
(function (GetUserRunRequestIncludeFields) {
    GetUserRunRequestIncludeFields["CatalogDescription"] = "CatalogDescription";
})(GetUserRunRequestIncludeFields = exports.GetUserRunRequestIncludeFields || (exports.GetUserRunRequestIncludeFields = {}));
class Instrument {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.serialNumber = _data["serialNumber"];
            this.instrumentType = _data["instrumentType"];
            this.sideCount = _data["sideCount"];
            if (Array.isArray(_data["software"])) {
                this.software = [];
                for (let item of _data["software"])
                    this.software.push(Software.fromJS(item));
            }
            this.name = _data["name"];
            this.lastRunStartDate = _data["lastRunStartDate"] ? new Date(_data["lastRunStartDate"].toString()) : undefined;
            this.lastDxRunStartDate = _data["lastDxRunStartDate"] ? new Date(_data["lastDxRunStartDate"].toString()) : undefined;
            this.lastDiagnosticsDate = _data["lastDiagnosticsDate"] ? new Date(_data["lastDiagnosticsDate"].toString()) : undefined;
            this.lastConnectedEnvironmentId = _data["lastConnectedEnvironmentId"];
            if (Array.isArray(_data["activeRuns"])) {
                this.activeRuns = [];
                for (let item of _data["activeRuns"])
                    this.activeRuns.push(Run.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Instrument();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["serialNumber"] = this.serialNumber;
        data["instrumentType"] = this.instrumentType;
        data["sideCount"] = this.sideCount;
        if (Array.isArray(this.software)) {
            data["software"] = [];
            for (let item of this.software)
                data["software"].push(item.toJSON());
        }
        data["name"] = this.name;
        data["lastRunStartDate"] = this.lastRunStartDate ? this.lastRunStartDate.toISOString() : undefined;
        data["lastDxRunStartDate"] = this.lastDxRunStartDate ? this.lastDxRunStartDate.toISOString() : undefined;
        data["lastDiagnosticsDate"] = this.lastDiagnosticsDate ? this.lastDiagnosticsDate.toISOString() : undefined;
        data["lastConnectedEnvironmentId"] = this.lastConnectedEnvironmentId;
        if (Array.isArray(this.activeRuns)) {
            data["activeRuns"] = [];
            for (let item of this.activeRuns)
                data["activeRuns"].push(item.toJSON());
        }
        return data;
    }
}
exports.Instrument = Instrument;
var InstrumentPlatform;
(function (InstrumentPlatform) {
    InstrumentPlatform["Unknown"] = "Unknown";
    InstrumentPlatform["HiSeq"] = "HiSeq";
    InstrumentPlatform["MiSeq"] = "MiSeq";
    InstrumentPlatform["Eco"] = "Eco";
    InstrumentPlatform["IScan"] = "iScan";
    InstrumentPlatform["HiSeqX"] = "HiSeqX";
    InstrumentPlatform["NeoPrep"] = "NeoPrep";
    InstrumentPlatform["MiniSeq"] = "MiniSeq";
    InstrumentPlatform["NovaSeq"] = "NovaSeq";
    InstrumentPlatform["ISeq"] = "iSeq";
    InstrumentPlatform["TruSightNIPT"] = "TruSightNIPT";
    InstrumentPlatform["NextSeq"] = "NextSeq";
    InstrumentPlatform["NextSeq1k2k"] = "NextSeq1k2k";
    InstrumentPlatform["NovaSeqXSeries"] = "NovaSeqXSeries";
})(InstrumentPlatform = exports.InstrumentPlatform || (exports.InstrumentPlatform = {}));
class InstrumentTimeSeriesChartItem {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.value = _data["value"];
            this.apiUrl = _data["apiUrl"];
            this.runId = _data["runId"];
            this.instrumentStartedOnDate = _data["instrumentStartedOnDate"] ? new Date(_data["instrumentStartedOnDate"].toString()) : undefined;
            this.serialNumber = _data["serialNumber"];
            this.catalogNumber = _data["catalogNumber"];
            this.side = _data["side"];
            this.instrumentName = _data["instrumentName"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new InstrumentTimeSeriesChartItem();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["value"] = this.value;
        data["apiUrl"] = this.apiUrl;
        data["runId"] = this.runId;
        data["instrumentStartedOnDate"] = this.instrumentStartedOnDate ? this.instrumentStartedOnDate.toISOString() : undefined;
        data["serialNumber"] = this.serialNumber;
        data["catalogNumber"] = this.catalogNumber;
        data["side"] = this.side;
        data["instrumentName"] = this.instrumentName;
        return data;
    }
}
exports.InstrumentTimeSeriesChartItem = InstrumentTimeSeriesChartItem;
class InstrumentTimeSeriesChartItemUnpagedItems {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (let item of _data["items"])
                    this.items.push(InstrumentTimeSeriesChartItem.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new InstrumentTimeSeriesChartItemUnpagedItems();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}
exports.InstrumentTimeSeriesChartItemUnpagedItems = InstrumentTimeSeriesChartItemUnpagedItems;
var InstrumentTimeSeriesMetricName;
(function (InstrumentTimeSeriesMetricName) {
    InstrumentTimeSeriesMetricName["Yield"] = "Yield";
    InstrumentTimeSeriesMetricName["ReadsPf"] = "ReadsPf";
    InstrumentTimeSeriesMetricName["PercentGtQ30"] = "PercentGtQ30";
    InstrumentTimeSeriesMetricName["PercentAligned"] = "PercentAligned";
    InstrumentTimeSeriesMetricName["ClustersPf"] = "ClustersPf";
    InstrumentTimeSeriesMetricName["PercentPf"] = "PercentPf";
    InstrumentTimeSeriesMetricName["ErrorRate"] = "ErrorRate";
    InstrumentTimeSeriesMetricName["IntensityCycle1"] = "IntensityCycle1";
    InstrumentTimeSeriesMetricName["PercentResynthesis"] = "PercentResynthesis";
})(InstrumentTimeSeriesMetricName = exports.InstrumentTimeSeriesMetricName || (exports.InstrumentTimeSeriesMetricName = {}));
class InstrumentUnpagedItems {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (let item of _data["items"])
                    this.items.push(Instrument.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new InstrumentUnpagedItems();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}
exports.InstrumentUnpagedItems = InstrumentUnpagedItems;
class InstrumentUtilization {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.instrumentId = _data["instrumentId"];
            this.name = _data["name"];
            this.serialNumber = _data["serialNumber"];
            this.instrumentType = _data["instrumentType"];
            this.totalRunTime = _data["totalRunTime"];
            this.fromDate = _data["fromDate"] ? new Date(_data["fromDate"].toString()) : undefined;
            this.toDate = _data["toDate"] ? new Date(_data["toDate"].toString()) : undefined;
            this.incompleteRunsExcluded = _data["incompleteRunsExcluded"];
            if (Array.isArray(_data["bins"])) {
                this.bins = [];
                for (let item of _data["bins"])
                    this.bins.push(InstrumentUtilizationBin.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new InstrumentUtilization();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["instrumentId"] = this.instrumentId;
        data["name"] = this.name;
        data["serialNumber"] = this.serialNumber;
        data["instrumentType"] = this.instrumentType;
        data["totalRunTime"] = this.totalRunTime;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : undefined;
        data["incompleteRunsExcluded"] = this.incompleteRunsExcluded;
        if (Array.isArray(this.bins)) {
            data["bins"] = [];
            for (let item of this.bins)
                data["bins"].push(item.toJSON());
        }
        return data;
    }
}
exports.InstrumentUtilization = InstrumentUtilization;
class InstrumentUtilizationBin {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.fromDate = _data["fromDate"] ? new Date(_data["fromDate"].toString()) : undefined;
            this.toDate = _data["toDate"] ? new Date(_data["toDate"].toString()) : undefined;
            this.totalRunTimeHours = _data["totalRunTimeHours"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new InstrumentUtilizationBin();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : undefined;
        data["totalRunTimeHours"] = this.totalRunTimeHours;
        return data;
    }
}
exports.InstrumentUtilizationBin = InstrumentUtilizationBin;
class InstrumentUtilizationUnpagedItems {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (let item of _data["items"])
                    this.items.push(InstrumentUtilization.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new InstrumentUtilizationUnpagedItems();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}
exports.InstrumentUtilizationUnpagedItems = InstrumentUtilizationUnpagedItems;
class InstrumentWash {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.serialNumber = _data["serialNumber"];
            this.startedOn = _data["startedOn"] ? new Date(_data["startedOn"].toString()) : undefined;
            this.completedOn = _data["completedOn"] ? new Date(_data["completedOn"].toString()) : undefined;
            this.mode = _data["mode"];
            this.status = _data["status"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new InstrumentWash();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["serialNumber"] = this.serialNumber;
        data["startedOn"] = this.startedOn ? this.startedOn.toISOString() : undefined;
        data["completedOn"] = this.completedOn ? this.completedOn.toISOString() : undefined;
        data["mode"] = this.mode;
        data["status"] = this.status;
        return data;
    }
}
exports.InstrumentWash = InstrumentWash;
class InstrumentWashUnpagedItems {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (let item of _data["items"])
                    this.items.push(InstrumentWash.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new InstrumentWashUnpagedItems();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}
exports.InstrumentWashUnpagedItems = InstrumentWashUnpagedItems;
class Run {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.number = _data["number"];
            this.status = _data["status"];
            this.side = _data["side"];
            this.instrumentStartedDate = _data["instrumentStartedDate"] ? new Date(_data["instrumentStartedDate"].toString()) : undefined;
            this.instrumentCompletedDate = _data["instrumentCompletedDate"] ? new Date(_data["instrumentCompletedDate"].toString()) : undefined;
            this.totalSize = _data["totalSize"];
            this.workflow = _data["workflow"];
            this.instrumentSerialNumber = _data["instrumentSerialNumber"];
            this.apiUrl = _data["apiUrl"];
            this.runId = _data["runId"];
            this.experimentName = _data["experimentName"];
            this.hrefBaseSpaceUI = _data["hrefBaseSpaceUI"];
            this.isDxRun = _data["isDxRun"];
            this.consumables = _data["consumables"] ? Consumables.fromJS(_data["consumables"]) : undefined;
            this.sequencingStats = _data["sequencingStats"] ? SequencingStats.fromJS(_data["sequencingStats"]) : undefined;
            this.runMode = _data["runMode"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Run();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["number"] = this.number;
        data["status"] = this.status;
        data["side"] = this.side;
        data["instrumentStartedDate"] = this.instrumentStartedDate ? this.instrumentStartedDate.toISOString() : undefined;
        data["instrumentCompletedDate"] = this.instrumentCompletedDate ? this.instrumentCompletedDate.toISOString() : undefined;
        data["totalSize"] = this.totalSize;
        data["workflow"] = this.workflow;
        data["instrumentSerialNumber"] = this.instrumentSerialNumber;
        data["apiUrl"] = this.apiUrl;
        data["runId"] = this.runId;
        data["experimentName"] = this.experimentName;
        data["hrefBaseSpaceUI"] = this.hrefBaseSpaceUI;
        data["isDxRun"] = this.isDxRun;
        data["consumables"] = this.consumables ? this.consumables.toJSON() : undefined;
        data["sequencingStats"] = this.sequencingStats ? this.sequencingStats.toJSON() : undefined;
        data["runMode"] = this.runMode;
        return data;
    }
}
exports.Run = Run;
class RunPagedItems {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (let item of _data["items"])
                    this.items.push(Run.fromJS(item));
            }
            this.itemCount = _data["itemCount"];
            this.firstPageToken = _data["firstPageToken"];
            this.nextPageToken = _data["nextPageToken"];
            this.prevPageToken = _data["prevPageToken"];
            this.lastPageToken = _data["lastPageToken"];
            this.totalItemCount = _data["totalItemCount"];
            this.totalPageCount = _data["totalPageCount"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new RunPagedItems();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["itemCount"] = this.itemCount;
        data["firstPageToken"] = this.firstPageToken;
        data["nextPageToken"] = this.nextPageToken;
        data["prevPageToken"] = this.prevPageToken;
        data["lastPageToken"] = this.lastPageToken;
        data["totalItemCount"] = this.totalItemCount;
        data["totalPageCount"] = this.totalPageCount;
        return data;
    }
}
exports.RunPagedItems = RunPagedItems;
class SequencingStats {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.maxCycleScored = _data["maxCycleScored"];
            this.maxCycleCalled = _data["maxCycleCalled"];
            this.readsPfTotal = _data["readsPfTotal"];
            this.clustersPf = _data["clustersPf"];
            this.numCyclesIndex1 = _data["numCyclesIndex1"];
            this.numCyclesIndex2 = _data["numCyclesIndex2"];
            this.numCyclesRead1 = _data["numCyclesRead1"];
            this.numCyclesRead2 = _data["numCyclesRead2"];
            this.percentGtQ30 = _data["percentGtQ30"];
            this.percentPf = _data["percentPf"];
            this.yieldTotal = _data["yieldTotal"];
            this.errorRate = _data["errorRate"];
            this.percentAligned = _data["percentAligned"];
            this.percentResynthesis = _data["percentResynthesis"];
            this.isIndexed = _data["isIndexed"];
            this.intensityCycle1 = _data["intensityCycle1"];
            this.isPairedEnd = _data["isPairedEnd"];
            this.occupancy = _data["occupancy"];
            this.clusterDensity = _data["clusterDensity"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SequencingStats();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["maxCycleScored"] = this.maxCycleScored;
        data["maxCycleCalled"] = this.maxCycleCalled;
        data["readsPfTotal"] = this.readsPfTotal;
        data["clustersPf"] = this.clustersPf;
        data["numCyclesIndex1"] = this.numCyclesIndex1;
        data["numCyclesIndex2"] = this.numCyclesIndex2;
        data["numCyclesRead1"] = this.numCyclesRead1;
        data["numCyclesRead2"] = this.numCyclesRead2;
        data["percentGtQ30"] = this.percentGtQ30;
        data["percentPf"] = this.percentPf;
        data["yieldTotal"] = this.yieldTotal;
        data["errorRate"] = this.errorRate;
        data["percentAligned"] = this.percentAligned;
        data["percentResynthesis"] = this.percentResynthesis;
        data["isIndexed"] = this.isIndexed;
        data["intensityCycle1"] = this.intensityCycle1;
        data["isPairedEnd"] = this.isPairedEnd;
        data["occupancy"] = this.occupancy;
        data["clusterDensity"] = this.clusterDensity;
        return data;
    }
}
exports.SequencingStats = SequencingStats;
class Software {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.applicationName = _data["applicationName"];
            this.version = _data["version"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Software();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["applicationName"] = this.applicationName;
        data["version"] = this.version;
        return data;
    }
}
exports.Software = Software;
class IpsApiException extends Error {
    constructor(message, status, response, headers, result) {
        super();
        this.isIpsApiException = true;
        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }
    static isIpsApiException(obj) {
        return obj.isIpsApiException === true;
    }
}
exports.IpsApiException = IpsApiException;
function throwException(message, status, response, headers, result) {
    return rxjs_1.throwError(new IpsApiException(message, status, response, headers, result));
}
function blobToText(blob) {
    return new rxjs_1.Observable((observer) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        }
        else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next(event.target.result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}
//# sourceMappingURL=ips.js.map